import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { api, CATEGORIES } from "@/lib/api";

const EMPTY = { name: "", category: "planner", price: 0, description: "", image: "", badge: "", stock: 0, is_digital: false, featured: false, grants_app: false, file_name: "", active: true, coming_soon: false };

const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">{label}</span>
    {children}
  </label>
);

export const ProductForm = ({ open, onOpenChange, initial, onSave, saving }) => {
  const [f, setF] = useState(EMPTY);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (open) api.get("/admin/files").then((r) => setFiles(Array.isArray(r.data) ? r.data : [])).catch(() => setFiles([]));
  }, [open]);

  useEffect(() => {
    if (open) setF(initial ? { ...EMPTY, ...initial } : EMPTY);
  }, [open, initial]);

  const set = (k) => (e) => setF((v) => ({ ...v, [k]: e?.target ? e.target.value : e }));
  const submit = (e) => {
    e.preventDefault();
    const { id, ...rest } = f;
    onSave({ ...rest, price: Number(rest.price), stock: parseInt(rest.stock, 10) || 0 });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="product-form-dialog" data-lenis-prevent className="max-h-[90vh] overflow-y-auto border-[rgba(152,191,162,0.25)] bg-[#0b120e]">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-900 uppercase">{initial ? "Modifica prodotto" : "Nuovo prodotto"}</DialogTitle>
          <DialogDescription className="text-[#a3b1aa]">I prezzi sono in euro.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Nome"><Input data-testid="product-form-name" required value={f.name} onChange={set("name")} /></Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Categoria">
              <select data-testid="product-form-category" value={f.category} onChange={set("category")}
                className="h-10 w-full rounded-md border border-input bg-transparent px-3 text-sm">
                {CATEGORIES.filter((c) => c.key).map((c) => <option key={c.key} value={c.key} className="bg-[#0b120e]">{c.label}</option>)}
              </select>
            </Field>
            <Field label="Prezzo €"><Input data-testid="product-form-price" type="number" step="0.01" min="0.5" required value={f.price} onChange={set("price")} /></Field>
            <Field label="Stock"><Input data-testid="product-form-stock" type="number" min="0" value={f.stock} onChange={set("stock")} /></Field>
            <Field label="Badge"><Input data-testid="product-form-badge" value={f.badge} onChange={set("badge")} /></Field>
          </div>
          <Field label="URL immagine"><Input data-testid="product-form-image" placeholder="https://… o /images/…" value={f.image} onChange={set("image")} /></Field>
          <Field label="File PDF da consegnare">
            <select data-testid="product-form-file" value={f.file_name} onChange={set("file_name")}
              className="h-10 w-full rounded-md border border-input bg-transparent px-3 text-sm">
              <option value="" className="bg-[#0b120e]">Nessun file</option>
              {files.map((n) => <option key={n} value={n} className="bg-[#0b120e]">{n}</option>)}
            </select>
          </Field>
          <Field label="Descrizione"><Textarea data-testid="product-form-description" rows={3} value={f.description} onChange={set("description")} /></Field>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <label className="flex items-center gap-3 text-sm"><Switch data-testid="product-form-digital" checked={f.is_digital} onCheckedChange={set("is_digital")} /> Digitale</label>
            <label className="flex items-center gap-3 text-sm"><Switch data-testid="product-form-featured" checked={f.featured} onCheckedChange={set("featured")} /> In evidenza</label>
            <label className="flex items-center gap-3 text-sm"><Switch data-testid="product-form-grants-app" checked={f.grants_app} onCheckedChange={set("grants_app")} /> Sblocca app NUTRI</label>
            <label className="flex items-center gap-3 text-sm"><Switch data-testid="product-form-active" checked={f.active} onCheckedChange={set("active")} /> Visibile sul sito</label>
            <label className="flex items-center gap-3 text-sm"><Switch data-testid="product-form-coming-soon" checked={f.coming_soon} onCheckedChange={set("coming_soon")} /> In arrivo (non acquistabile)</label>
          </div>
          <button data-testid="product-form-submit" disabled={saving}
            className="w-full bg-[#98bfa2] py-3 font-display text-lg font-800 uppercase text-[#050807] hover:bg-[#c4dcca] disabled:opacity-50">
            {saving ? "Salvataggio…" : "Salva prodotto"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
